import { SvgIcon, SvgIconProps } from "@mui/material";

export const MailboxIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      aria-label="mailbox"
    >
      <rect
        width="18"
        height="14"
        x="3"
        y="5"
        stroke="#A094FF"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        rx="3"
      />
      <path
        stroke="#A094FF"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="m7.5 9.75 2.925 1.804a3 3 0 0 0 3.15 0L16.5 9.75"
      />
    </svg>
    ;
  </SvgIcon>
);
